import {
  Box,
  Button,
  Container,
  Grid,
  Link,
  Typography,
  useTheme
} from "@mui/material";
import React, { useState } from "react";
import { BCPLockKeyhole } from "../../../components/icons/bcp/BCPIcons";
import Login from "./Login";
import { useTranslation } from "react-i18next";

export default function LoginRedirect() {
  const theme = useTheme();
  const [showLogin, setShowLogin] = useState(false);

  const { t } = useTranslation("translation", {
    keyPrefix: "components.LoginRedirect"
  });

  if (!showLogin) {
    return (
      <Box width="100%">
        <Container maxWidth="lg" sx={{ pt: 2, pb: 2 }}>
          <Grid
            container
            sx={{
              p: 2,
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
            spacing={1}
          >
            <Grid item xs={12}>
              <Typography variant="h3" sx={{ pt: 2 }}>
                {t("title")}
              </Typography>
            </Grid>

            <Grid item xs={12} sx={{ pt: 1, pb: 1 }}>
              <BCPLockKeyhole
                sx={{
                  fontSize: "50px",
                  width: "50px",
                  color: theme?.palette?.text?.disabled
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body1" paragraph>
                {t("description")}
                <Link href="/">{t("home")}</Link>.
              </Typography>
            </Grid>

            <Grid item xs={6}>
              <Button
                variant="contained"
                fullWidth
                onClick={() => {
                  setShowLogin(true);
                }}
              >
                {t("signIn")}
              </Button>
            </Grid>
          </Grid>
        </Container>
      </Box>
    );
  }

  return <Login />;
}
